/*
=========================================
QUESS TRAINING REGISTRATION MODAL
PART 2 — LEARNERS AND ASSIGNMENTS
=========================================
*/

(function () {
  "use strict";


  if (
    window.__quessTrainingRegistrationModalLoaded
  ) {
    return;
  }


  window.__quessTrainingRegistrationModalLoaded =
    true;


  const TYPE_DRAFT_STORAGE_KEY =
  "quess_training_registration_type_draft";


const TRAINING_REGISTRATION_ENDPOINT =
  "https://gurilkolwhwienvhorvm.supabase.co/functions/v1/training-registration";


const REGISTRATION_REQUEST_STORAGE_KEY =
  "quess_training_registration_request_state";


const PRIVATE_CART_ATTRIBUTE =
  "__quess_training_registration_id";


const shopifyRoot =
  (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  )
    ? window.Shopify.routes.root
    : "/";


const quessTrainingContext =
  window.QuessTrainingContext || {};


const routeCountryMatch =
  String(shopifyRoot || "").match(
    /^\/[a-z]{2}-([a-z]{2})(?:\/|$)/i
  );


const routeCountryCode =
  routeCountryMatch
    ? routeCountryMatch[1]
    : "";


const storefrontCountryCode =
  String(
    quessTrainingContext.countryCode ||
    routeCountryCode ||
    "CA"
  )
    .trim()
    .toUpperCase();


const isUnitedStatesMarket =
  storefrontCountryCode === "US";


let trainingCartState =
  window.QuessTrainingCart || null;


let isForOtherPeople = false;
let selectedLearnerCount = 1;
let learners = [];
let assignments = {};
let currentStep = "selection";
let lastFocusedElement = null;


let registrationSubmissionRunning =
  false;


let savedRegistrationId =
  null;


  const registrationConsent = {
    informationConfirmed: false,
    processingConsent: false,
    termsAccepted: false
  };


  /*
  =========================================
  BASIC HELPERS
  =========================================
  */

  function escapeHtml(
    value
  ) {
    return String(
      value ?? ""
    )
      .replaceAll(
        "&",
        "&amp;"
      )
      .replaceAll(
        "<",
        "&lt;"
      )
      .replaceAll(
        ">",
        "&gt;"
      )
      .replaceAll(
        '"',
        "&quot;"
      )
      .replaceAll(
        "'",
        "&#039;"
      );
  }


  function createEmptyLearner(
    learnerNumber
  ) {
    return {
      learnerNumber,

      firstName: "",
      lastName: "",
      email: "",
      requestedUsername: "",
      phone: "",
      gender: "",
      professionalTitle: "",
      country: "",
      provinceState: "",
      addressLine1: "",
      addressLine2: "",
      postalCode: "",
      dateOfBirthMonthDay: "",
      cpeMonitorId: "",


      marketingConsent: false
    };
  }


  function ensureLearnerCount() {
    const requiredCount =
      Math.max(
        1,
        selectedLearnerCount
      );


    while (
      learners.length <
      requiredCount
    ) {
      learners.push(
        createEmptyLearner(
          learners.length + 1
        )
      );
    }


    if (
      learners.length >
      requiredCount
    ) {
      learners =
        learners.slice(
          0,
          requiredCount
        );
    }


    learners.forEach(
      function (
        learner,
        index
      ) {
        learner.learnerNumber =
          index + 1;
      }
    );


    pruneInvalidAssignments();
  }


  function getTrainingItems() {
    return Array.isArray(
      trainingCartState
        ?.trainingItems
    )
      ? trainingCartState.trainingItems
      : [];
  }


  function getMinimumLearnerCount() {
    return Math.max(
      1,

      Number(
        trainingCartState
          ?.minimumLearnerCount || 1
      )
    );
  }


  function getMaximumLearnerCount() {
    return Math.max(
      getMinimumLearnerCount(),

      Number(
        trainingCartState
          ?.maximumLearnerCount || 1
      )
    );
  }


  function clampLearnerCount(
    value
  ) {
    const minimum =
      getMinimumLearnerCount();


    const maximum =
      getMaximumLearnerCount();


    const numericValue =
      Number(
        value
      );


    if (
      !Number.isFinite(
        numericValue
      )
    ) {
      return minimum;
    }


    return Math.min(
      maximum,

      Math.max(
        minimum,
        Math.round(
          numericValue
        )
      )
    );
  }


  function getCourseAssignmentKey(
    trainingItem
  ) {
    return String(
      trainingItem.variantId ||
      trainingItem.lineKey ||
      ""
    );
  }


  function getAssignedLearnerNumbers(
    trainingItem
  ) {
    const key =
      getCourseAssignmentKey(
        trainingItem
      );


    if (
      !Array.isArray(
        assignments[key]
      )
    ) {
      assignments[key] = [];
    }


    return assignments[key];
  }


  function pruneInvalidAssignments() {
    const validLearnerNumbers =
      new Set(
        learners.map(
          function (
            learner
          ) {
            return learner.learnerNumber;
          }
        )
      );


    Object.keys(
      assignments
    ).forEach(
      function (
        key
      ) {
        assignments[key] =
          assignments[key]
            .filter(
              function (
                learnerNumber
              ) {
                return validLearnerNumbers.has(
                  learnerNumber
                );
              }
            );
      }
    );
  }


  function initializeAssignments() {
    ensureLearnerCount();


    getTrainingItems().forEach(
      function (
        trainingItem
      ) {
        const key =
          getCourseAssignmentKey(
            trainingItem
          );


        const seatQuantity =
          Number(
            trainingItem.quantity || 0
          );


        const existing =
          getAssignedLearnerNumbers(
            trainingItem
          );


        /*
        When every learner receives the
        course, assign it automatically.
        */

        if (
          seatQuantity ===
          selectedLearnerCount
        ) {
          assignments[key] =
            learners.map(
              function (
                learner
              ) {
                return learner.learnerNumber;
              }
            );

          return;
        }


        assignments[key] =
          existing.slice(
            0,
            seatQuantity
          );
      }
    );
  }


  function getLearnerDisplayName(
    learner
  ) {
    const fullName =
      [
        learner.firstName,
        learner.lastName
      ]
        .filter(Boolean)
        .join(" ")
        .trim();


    if (fullName) {
      return fullName;
    }


    return `Learner ${learner.learnerNumber}`;
  }


  /*
  =========================================
  CREATE MODAL
  =========================================
  */

  function createTrainingRegistrationModal() {
    let overlay =
      document.getElementById(
        "quess-training-registration-overlay"
      );


    if (overlay) {
      return overlay;
    }


    const style =
      document.createElement(
        "style"
      );


    style.textContent = `
      #quess-training-registration-overlay {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgba(19, 42, 56, 0.68);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        opacity: 0;
        visibility: hidden;
        transition:
          opacity 100ms ease,
          visibility 100ms ease;
      }

      #quess-training-registration-overlay.is-visible {
        opacity: 1;
        visibility: visible;
      }

      #quess-training-registration-modal {
        position: relative;
        width: 100%;
        max-width: 900px;
        max-height: calc(100vh - 48px);
        overflow-y: auto;
        padding: 34px;
        border-radius: 18px;
        background: #ffffff;
        color: #263844;
        box-shadow:
          0 26px 80px
          rgba(0, 0, 0, 0.28);
        transform: translateY(10px);
        transition:
          transform 100ms ease;
      }

      #quess-training-registration-overlay.is-visible
      #quess-training-registration-modal {
        transform: translateY(0);
      }

      .quess-training-modal-close {
        position: absolute;
        top: 18px;
        right: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: #edf4f8;
        color: #263844;
        font-size: 25px;
        cursor: pointer;
      }

      .quess-training-modal-eyebrow {
        margin: 0 46px 7px 0;
        color: #0068a5;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      .quess-training-step-title {
        margin: 0 46px 10px 0;
        color: #263844;
        font-size: 28px;
        line-height: 1.25;
      }

      .quess-training-step-description {
        margin: 0;
        color: #5a6c77;
        font-size: 16px;
        line-height: 1.6;
      }

      .quess-training-progress {
        display: grid;
        grid-template-columns:
          repeat(3, minmax(0, 1fr));
        gap: 8px;
        margin: 26px 0;
      }

      .quess-training-progress-step {
        padding: 10px;
        border-radius: 8px;
        background: #edf2f5;
        color: #72828b;
        font-size: 13px;
        font-weight: 700;
        text-align: center;
      }

      .quess-training-progress-step.is-active {
        background: #0068a5;
        color: #ffffff;
      }

      .quess-training-progress-step.is-complete {
        background: #dceef8;
        color: #0068a5;
      }

      .quess-training-cart-summary,
      .quess-training-choice-card,
      .quess-training-assignment-card,
      .quess-training-consent-card {
        margin-top: 22px;
        padding: 21px;
        border: 1px solid #dce7ed;
        border-radius: 13px;
        background: #ffffff;
      }

      .quess-training-cart-summary {
        background: #f7fafc;
      }

      .quess-training-cart-summary h3,
      .quess-training-choice-card h3,
      .quess-training-assignment-card h3,
      .quess-training-consent-card h3 {
        margin: 0 0 14px;
        color: #263844;
        font-size: 18px;
      }

      #quess-training-summary-list {
        display: flex;
        flex-direction: column;
        gap: 9px;
        margin: 0;
        padding: 0;
        list-style: none;
      }

      .quess-training-summary-item {
        display: flex;
        justify-content: space-between;
        gap: 18px;
        padding-bottom: 9px;
        border-bottom: 1px solid #e3ebef;
      }

      .quess-training-summary-item:last-child {
        padding-bottom: 0;
        border-bottom: 0;
      }

      .quess-training-summary-title {
        font-weight: 650;
      }

      .quess-training-summary-quantity {
        flex-shrink: 0;
        color: #0068a5;
        font-weight: 750;
      }

      .quess-training-for-others-label,
      .quess-training-consent-label,
      .quess-training-assignment-option {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        cursor: pointer;
      }

      .quess-training-for-others-label input,
      .quess-training-consent-label input,
      .quess-training-assignment-option input {
        width: 19px;
        height: 19px;
        margin: 2px 0 0;
        accent-color: #0068a5;
        flex-shrink: 0;
      }

      .quess-training-checkbox-title {
        display: block;
        color: #263844;
        font-weight: 700;
      }

      .quess-training-checkbox-description {
        display: block;
        margin-top: 4px;
        color: #61737e;
        font-size: 14px;
        line-height: 1.5;
      }

      #quess-training-count-section {
        display: none;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #e3ebef;
      }

      #quess-training-count-section.is-visible {
        display: block;
      }

      .quess-training-count-control {
        display: inline-flex;
        align-items: center;
        overflow: hidden;
        border: 1px solid #b9ccd6;
        border-radius: 10px;
      }

      .quess-training-count-button {
        width: 46px;
        height: 44px;
        padding: 0;
        border: 0;
        background: #edf4f8;
        color: #0068a5;
        font-size: 23px;
        cursor: pointer;
      }

      .quess-training-count-button:disabled {
        opacity: 0.42;
        cursor: not-allowed;
      }

      #quess-training-learner-count {
        width: 64px;
        height: 44px;
        border: 0;
        border-left: 1px solid #b9ccd6;
        border-right: 1px solid #b9ccd6;
        font-family: inherit;
        font-size: 17px;
        font-weight: 700;
        text-align: center;
      }

      #quess-training-count-range {
        margin-top: 10px;
        color: #61737e;
        font-size: 13px;
      }

      .quess-training-learner-card {
        margin-top: 20px;
        overflow: hidden;
        border: 1px solid #d7e3e9;
        border-radius: 13px;
        background: #ffffff;
      }

      .quess-training-learner-card summary {
        padding: 17px 20px;
        background: #f3f8fb;
        color: #263844;
        font-weight: 750;
        cursor: pointer;
      }

      .quess-training-learner-fields {
        padding: 22px;
      }

      .quess-training-form-grid {
        display: grid;
        grid-template-columns:
          repeat(2, minmax(0, 1fr));
        gap: 17px;
      }

      .quess-training-field {
        display: flex;
        flex-direction: column;
        gap: 7px;
      }

      .quess-training-field--full {
        grid-column: 1 / -1;
      }

      .quess-training-field label {
        color: #263844;
        font-size: 14px;
        font-weight: 700;
      }

      .quess-training-required {
        color: #b42d2d;
      }

      .quess-training-field input,
      .quess-training-field select {
        width: 100%;
        min-height: 45px;
        padding: 10px 12px;
        border: 1px solid #b9ccd6;
        border-radius: 8px;
        background: #ffffff;
        color: #263844;
        font: inherit;
      }

      .quess-training-field input:focus,
      .quess-training-field select:focus {
        border-color: #0068a5;
        outline: 3px solid
          rgba(0, 104, 165, 0.13);
      }


      .quess-training-address-field {
        position: relative;
      }

      .quess-training-address-suggestions {
        position: absolute;
        z-index: 20;
        top: calc(100% + 4px);
        right: 0;
        left: 0;
        overflow: hidden;
        border: 1px solid #b9ccd6;
        border-radius: 8px;
        background: #ffffff;
        box-shadow:
          0 12px 30px
          rgba(25, 53, 68, 0.18);
      }

      .quess-training-address-suggestions[hidden] {
        display: none;
      }

      .quess-training-address-results {
        display: grid;
        max-height: 250px;
        overflow-y: auto;
      }

      .quess-training-address-option {
        width: 100%;
        padding: 11px 12px;
        border: 0;
        border-bottom:
          1px solid #e5edf1;
        background: #ffffff;
        color: #263844;
        font: inherit;
        text-align: left;
        cursor: pointer;
      }

      .quess-training-address-option:hover,
      .quess-training-address-option:focus,
      .quess-training-address-option.is-active {
        background: #edf6fb;
        outline: none;
      }

      .quess-training-address-attribution {
        padding: 7px 10px;
        background: #f7fafc;
        color: #647985;
        font-size: 10px;
        text-align: right;
      }

      .quess-training-address-attribution a {
        color: inherit;
        text-decoration: underline;
      }

      .quess-training-inline-checkbox {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        grid-column: 1 / -1;
        padding: 13px;
        border-radius: 8px;
        background: #f7fafc;
      }

      .quess-training-inline-checkbox input {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        accent-color: #0068a5;
      }

      .quess-training-cpe-id[hidden] {
        display: none;
      }

      .quess-training-assignment-card {
        background: #f8fbfd;
      }

      .quess-training-assignment-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 18px;
      }

      .quess-training-assignment-counter {
        flex-shrink: 0;
        padding: 6px 10px;
        border-radius: 20px;
        background: #e4edf2;
        color: #536875;
        font-size: 13px;
        font-weight: 750;
      }

      .quess-training-assignment-counter.is-complete {
        background: #dff2e5;
        color: #246b38;
      }

      .quess-training-assignment-options {
        display: grid;
        gap: 10px;
        margin-top: 16px;
      }

      .quess-training-assignment-option {
        padding: 12px;
        border: 1px solid #d8e4ea;
        border-radius: 9px;
        background: #ffffff;
      }

      .quess-training-assignment-option.is-disabled {
        opacity: 0.55;
      }

      .quess-training-assignment-email {
        display: block;
        margin-top: 2px;
        color: #647985;
        font-size: 13px;
      }

      .quess-training-automatic-note {
        margin: 13px 0 0;
        color: #61737e;
        font-size: 13px;
      }

      .quess-training-consent-list {
        display: grid;
        gap: 15px;
      }

      #quess-training-registration-error {
        display: none;
        margin-top: 18px;
        padding: 14px 16px;
        border: 1px solid #d98b8b;
        border-radius: 9px;
        background: #fff5f5;
        color: #9e2929;
        font-size: 14px;
        line-height: 1.5;
      }

      #quess-training-registration-error.is-visible {
        display: block;
      }

      .quess-training-modal-actions {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        margin-top: 25px;
      }

      .quess-training-actions-right {
        display: flex;
        gap: 12px;
      }

      .quess-training-secondary-button,
      .quess-training-primary-button {
        min-height: 46px;
        padding: 11px 21px;
        border-radius: 9px;
        font-family: inherit;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
      }

      .quess-training-secondary-button {
        border: 1px solid #b9ccd6;
        background: #ffffff;
        color: #3f5664;
      }

      .quess-training-primary-button {
        border: 1px solid #0068a5;
        background: #0068a5;
        color: #ffffff;
      }

      .quess-training-primary-button:disabled {
        opacity: 0.65;
        cursor: wait;
        }

      #quess-training-ready-step {
        display: none;
        padding: 30px 0 5px;
        text-align: center;
      }

      #quess-training-ready-step.is-visible {
        display: block;
      }

      .quess-training-ready-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 62px;
        height: 62px;
        margin: 0 auto 17px;
        border-radius: 50%;
        background: #dff2e5;
        color: #246b38;
        font-size: 30px;
        font-weight: 800;
      }

      body.quess-training-modal-open {
        overflow: hidden;
      }

      html.quess-cart-has-training
      .additional-checkout-buttons,

      html.quess-cart-has-training
      .dynamic-checkout__content,

      html.quess-cart-has-training
      [data-shopify-buttoncontainer] {
        display: none !important;
      }

      @media screen and (max-width: 700px) {
        #quess-training-registration-overlay {
          padding: 12px;
        }

        #quess-training-registration-modal {
          max-height: calc(100vh - 24px);
          padding: 27px 18px;
          border-radius: 14px;
        }

        .quess-training-step-title {
          font-size: 23px;
        }

        .quess-training-form-grid {
          grid-template-columns: 1fr;
        }

        .quess-training-field--full {
          grid-column: auto;
        }

        .quess-training-modal-actions,
        .quess-training-actions-right {
          flex-direction: column-reverse;
        }

        .quess-training-modal-actions,
        .quess-training-secondary-button,
        .quess-training-primary-button {
          width: 100%;
        }

        .quess-training-assignment-header {
          flex-direction: column;
        }
      }
    `;


    document.head.appendChild(
      style
    );


    overlay =
      document.createElement(
        "div"
      );


    overlay.id =
      "quess-training-registration-overlay";


    overlay.innerHTML = `
      <div
        id="quess-training-registration-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quess-training-registration-title"
      >
        <button
          type="button"
          class="quess-training-modal-close"
          aria-label="Close training registration"
        >
          ×
        </button>

        <div class="quess-training-progress">
          <div
            class="quess-training-progress-step"
            data-progress-step="selection"
          >
            1. Learners
          </div>

          <div
            class="quess-training-progress-step"
            data-progress-step="information"
          >
            2. Information
          </div>

          <div
            class="quess-training-progress-step"
            data-progress-step="assignment"
          >
            3. Assignments
          </div>
        </div>

        <div
          id="quess-training-selection-step"
          data-registration-step="selection"
        >
          <p class="quess-training-modal-eyebrow">
            QUESS LMS registration
          </p>

          <h2
            id="quess-training-registration-title"
            class="quess-training-step-title"
          >
            Register your training learners
          </h2>

          <p class="quess-training-step-description">
            Tell us who will complete the trainings
            in your cart.
          </p>

          <div class="quess-training-cart-summary">
            <h3>Trainings in your cart</h3>

            <ul id="quess-training-summary-list"></ul>
          </div>

          <div class="quess-training-choice-card">
            <h3>Who are the trainings for?</h3>

            <label class="quess-training-for-others-label">
              <input
                id="quess-training-for-others"
                type="checkbox"
              >

              <span>
                <span class="quess-training-checkbox-title">
                  The trainings are for other people
                </span>

                <span class="quess-training-checkbox-description">
                  Select this option when registering
                  one or more learners other than yourself.
                </span>
              </span>
            </label>

            <div id="quess-training-count-section">
              <label for="quess-training-learner-count">
                <strong>Number of learners</strong>
              </label>

              <p class="quess-training-step-description">
                You will complete one form per learner.
              </p>

              <div class="quess-training-count-control">
                <button
                  id="quess-training-count-minus"
                  class="quess-training-count-button"
                  type="button"
                >
                  −
                </button>

                <input
                  id="quess-training-learner-count"
                  type="number"
                  value="1"
                  min="1"
                  step="1"
                >

                <button
                  id="quess-training-count-plus"
                  class="quess-training-count-button"
                  type="button"
                >
                  +
                </button>
              </div>

              <div id="quess-training-count-range"></div>
            </div>
          </div>

          <div class="quess-training-modal-actions">
            <span></span>

            <div class="quess-training-actions-right">
              <button
                class="quess-training-secondary-button"
                data-close-registration
                type="button"
              >
                Return to cart
              </button>

              <button
                id="quess-training-selection-continue"
                class="quess-training-primary-button"
                type="button"
              >
                Continue
              </button>
            </div>
          </div>
        </div>

        <div
          id="quess-training-information-step"
          data-registration-step="information"
          hidden
        >
          <p class="quess-training-modal-eyebrow">
            Learner information
          </p>

          <h2 class="quess-training-step-title">
            Complete each learner form
          </h2>

          <p class="quess-training-step-description">
            Each learner must have a unique email
            address and username.
          </p>

          <div id="quess-training-learners-container"></div>

          <div class="quess-training-modal-actions">
            <button
              id="quess-training-information-back"
              class="quess-training-secondary-button"
              type="button"
            >
              Back
            </button>

            <button
              id="quess-training-information-continue"
              class="quess-training-primary-button"
              type="button"
            >
              Continue to assignments
            </button>
          </div>
        </div>

        <div
          id="quess-training-assignment-step"
          data-registration-step="assignment"
          hidden
        >
          <p class="quess-training-modal-eyebrow">
            Training assignments
          </p>

          <h2 class="quess-training-step-title">
            Assign trainings to learners
          </h2>

          <p class="quess-training-step-description">
            Every purchased seat must be assigned,
            and every learner must receive at least
            one training.
          </p>

          <div id="quess-training-assignments-container"></div>

          <div class="quess-training-consent-card">
            <h3>Confirmation and consent</h3>

            <div class="quess-training-consent-list">
              <label class="quess-training-consent-label">
                <input
                  id="quess-training-information-confirmed"
                  type="checkbox"
                >

                <span>
                  I confirm that the learner information
                  and training assignments are accurate.
                </span>
              </label>

              <label class="quess-training-consent-label">
                <input
                  id="quess-training-processing-consent"
                  type="checkbox"
                >

                <span>
                  I consent to QUESS 360 using this
                  information to process the registrations
                  and create the learners’ LMS access.
                </span>
              </label>

              <label class="quess-training-consent-label">
                <input
                  id="quess-training-terms-accepted"
                  type="checkbox"
                >

                <span>
                  I accept the QUESS 360 terms and conditions.
                </span>
              </label>
            </div>
          </div>

          <div class="quess-training-modal-actions">
            <button
              id="quess-training-assignment-back"
              class="quess-training-secondary-button"
              type="button"
            >
              Back
            </button>

            <button
  id="quess-training-registration-validate"
  class="quess-training-primary-button"
  type="button"
>
  Save and continue to checkout
</button>
          </div>
        </div>

        <div
          id="quess-training-registration-error"
          role="alert"
        ></div>

        <div id="quess-training-ready-step">
  <div class="quess-training-ready-icon">
    ✓
  </div>

  <h2 class="quess-training-step-title">
    Registration saved
  </h2>

  <p class="quess-training-step-description">
    Your learner information and training
    assignments were saved successfully.
  </p>

  <p class="quess-training-step-description">
    Opening secure Shopify Checkout…
  </p>
</div>
        </div>
      </div>
    `;


    document.body.appendChild(
      overlay
    );


    attachModalEvents(
      overlay
    );


    return overlay;
  }


  /*
  =========================================
  RENDERING
  =========================================
  */

  function renderTrainingSummary() {
    const list =
      document.getElementById(
        "quess-training-summary-list"
      );


    if (!list) {
      return;
    }


    list.innerHTML = "";


    getTrainingItems().forEach(
      function (
        item
      ) {
        const listItem =
          document.createElement(
            "li"
          );


        listItem.className =
          "quess-training-summary-item";


        listItem.innerHTML = `
          <span class="quess-training-summary-title">
            ${escapeHtml(
              item.productTitle ||
              "Training"
            )}
          </span>

          <span class="quess-training-summary-quantity">
            × ${Number(
              item.quantity || 0
            )}
          </span>
        `;


        list.appendChild(
          listItem
        );
      }
    );
  }


  function renderLearnerCount() {
    const input =
      document.getElementById(
        "quess-training-learner-count"
      );


    const minus =
      document.getElementById(
        "quess-training-count-minus"
      );


    const plus =
      document.getElementById(
        "quess-training-count-plus"
      );


    const range =
      document.getElementById(
        "quess-training-count-range"
      );


    if (
      !input ||
      !minus ||
      !plus ||
      !range
    ) {
      return;
    }


    const minimum =
      getMinimumLearnerCount();


    const maximum =
      getMaximumLearnerCount();


    selectedLearnerCount =
      clampLearnerCount(
        selectedLearnerCount
      );


    input.min =
      String(
        minimum
      );


    input.max =
      String(
        maximum
      );


    input.value =
      String(
        selectedLearnerCount
      );


    minus.disabled =
      selectedLearnerCount <=
      minimum;


    plus.disabled =
      selectedLearnerCount >=
      maximum;


    range.textContent =
      minimum === maximum
        ? `${minimum} learners are required.`
        : `Choose between ${minimum} and ${maximum} learners.`;
  }



  function getGeoapifyApiKey() {
    const config =
      window.QuessTrainingRegistrationConfig;

    return typeof config?.geoapifyApiKey ===
      "string"
        ? config.geoapifyApiKey.trim()
        : "";
  }


  function updateAddressField(
    container,
    learnerIndex,
    field,
    value
  ) {
    const input =
      container.querySelector(
        '[data-learner-index="' +
          learnerIndex +
          '"][data-learner-field="' +
          field +
          '"]'
      );

    if (
      !(
        input instanceof
        HTMLInputElement
      )
    ) {
      return;
    }

    input.value =
      String(value || "");
    input.dispatchEvent(
      new Event(
        "change",
        {
          bubbles: true
        }
      )
    );
  }


  function initializeAddressAutocomplete(
    container
  ) {
    const apiKey =
      getGeoapifyApiKey();

    if (!apiKey) {
      return;
    }

    const language =
      String(
        document.documentElement.lang ||
        "en"
      )
        .slice(0, 2)
        .toLowerCase();

    container
      .querySelectorAll(
        'input[data-learner-field="addressLine1"]'
      )
      .forEach(
        function (
          addressInput
        ) {
          if (
            !(
              addressInput instanceof
              HTMLInputElement
            ) ||
            addressInput.dataset
              .geoapifyReady === "true"
          ) {
            return;
          }

          const field =
            addressInput.closest(
              ".quess-training-field"
            );

          if (!field) {
            return;
          }

          addressInput.dataset
            .geoapifyReady = "true";

          addressInput.setAttribute(
            "autocomplete",
            "off"
          );

          field.classList.add(
            "quess-training-address-field"
          );

          const learnerIndex =
            Number(
              addressInput.getAttribute(
                "data-learner-index"
              )
            );

          const listId =
            "quess-training-address-suggestions-" +
            learnerIndex;

          const suggestions =
            document.createElement(
              "div"
            );

          suggestions.id =
            listId;

          suggestions.className =
            "quess-training-address-suggestions";

          suggestions.hidden =
            true;

          suggestions.setAttribute(
            "role",
            "listbox"
          );

          suggestions.innerHTML =
            '<div class="quess-training-address-results"></div>' +
            '<div class="quess-training-address-attribution">' +
            'Powered by <a href="https://www.geoapify.com/" target="_blank" rel="noopener noreferrer">Geoapify</a>' +
            ' · <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">© OpenStreetMap contributors</a>' +
            '</div>';

          field.appendChild(
            suggestions
          );

          const resultsContainer =
            suggestions.querySelector(
              ".quess-training-address-results"
            );

          addressInput.setAttribute(
            "aria-autocomplete",
            "list"
          );

          addressInput.setAttribute(
            "aria-controls",
            listId
          );

          addressInput.setAttribute(
            "aria-expanded",
            "false"
          );

          let debounceTimer =
            null;

          let activeRequest =
            null;

          let requestNumber =
            0;

          let currentResults =
            [];

          let activeOption =
            -1;

          function hideSuggestions() {
            suggestions.hidden =
              true;

            addressInput.setAttribute(
              "aria-expanded",
              "false"
            );

            addressInput.removeAttribute(
              "aria-activedescendant"
            );

            activeOption =
              -1;
          }

          function setActiveOption(
            nextIndex
          ) {
            const buttons =
              suggestions.querySelectorAll(
                ".quess-training-address-option"
              );

            if (!buttons.length) {
              return;
            }

            activeOption =
              (
                nextIndex +
                buttons.length
              ) %
              buttons.length;

            buttons.forEach(
              function (
                button,
                index
              ) {
                button.classList.toggle(
                  "is-active",
                  index === activeOption
                );
              }
            );

            const activeButton =
              buttons[
                activeOption
              ];

            addressInput.setAttribute(
              "aria-activedescendant",
              activeButton.id
            );
          }

          function selectAddress(
            result
          ) {
            const addressLine1 =
              [result.housenumber, result.street].filter(Boolean).join(" ") || result.address_line1 ||
              [
                result.housenumber,
                result.street
              ]
                .filter(Boolean)
                .join(" ");

            updateAddressField(
              container,
              learnerIndex,
              "addressLine1",
              addressLine1
            );

            updateAddressField(
              container,
              learnerIndex,
              "country",
              result.country
            );

            updateAddressField(
              container,
              learnerIndex,
              "provinceState",
              result.state ||
                result.state_code
            );

            updateAddressField(
              container,
              learnerIndex,
              "postalCode",
              result.postcode
            );

            hideSuggestions();

            const addressLine2 =
              container.querySelector(
                '[data-learner-index="' +
                  learnerIndex +
                  '"][data-learner-field="addressLine2"]'
              );

            if (
              addressLine2 instanceof
              HTMLInputElement
            ) {
              addressLine2.focus();
            }
          }

          function renderSuggestions(
            results
          ) {
            currentResults =
              results;

            resultsContainer
              .replaceChildren();

            if (!results.length) {
              hideSuggestions();

              return;
            }

            results.forEach(
              function (
                result,
                index
              ) {
                const button =
                  document.createElement(
                    "button"
                  );

                button.type =
                  "button";

                button.id =
                  listId +
                  "-option-" +
                  index;

                button.className =
                  "quess-training-address-option";

                button.setAttribute(
                  "role",
                  "option"
                );

                button.textContent =
                  result.formatted ||
                  result.address_line1 ||
                  "";

                button.addEventListener(
                  "pointerdown",
                  function (
                    event
                  ) {
                    event.preventDefault();
                  }
                );

                button.addEventListener(
                  "click",
                  function () {
                    selectAddress(
                      currentResults[
                        index
                      ]
                    );
                  }
                );

                resultsContainer
                  .appendChild(
                    button
                  );
              }
            );

            suggestions.hidden =
              false;

            addressInput.setAttribute(
              "aria-expanded",
              "true"
            );

            activeOption =
              -1;
          }

          addressInput.addEventListener(
            "input",
            function () {
              const query =
                addressInput.value.trim();

              window.clearTimeout(
                debounceTimer
              );

              if (activeRequest) {
                activeRequest.abort();
              }

              requestNumber +=
                1;

              if (query.length < 3) {
                hideSuggestions();

                return;
              }

              const thisRequest =
                requestNumber;

              debounceTimer =
                window.setTimeout(
                  async function () {
                    activeRequest =
                      new AbortController();

                    try {
                      const params =
                        new URLSearchParams({
                          text: query,
                          format: "json",
                          filter:
                            "countrycode:ca,us",
                          limit: "5",
                          lang:
                            language === "fr"
                              ? "fr"
                              : "en",
                          apiKey
                        });

                      const response =
                        await fetch(
                          "https://api.geoapify.com/v1/geocode/autocomplete?" +
                            params.toString(),
                          {
                            signal:
                              activeRequest
                                .signal
                          }
                        );

                      if (!response.ok) {
                        throw new Error(
                          "Address suggestions are temporarily unavailable."
                        );
                      }

                      const data =
                        await response.json();

                      if (
                        thisRequest !==
                        requestNumber
                      ) {
                        return;
                      }

                      renderSuggestions(
                        Array.isArray(
                          data.results
                        )
                          ? data.results
                          : []
                      );
                    }

                    catch (error) {
                      if (
                        error?.name !==
                        "AbortError"
                      ) {
                        hideSuggestions();
                      }
                    }
                  },
                  350
                );
            }
          );

          addressInput.addEventListener(
            "keydown",
            function (
              event
            ) {
              if (
                suggestions.hidden
              ) {
                return;
              }

              const optionCount =
                currentResults.length;

              if (
                event.key ===
                "ArrowDown"
              ) {
                event.preventDefault();

                setActiveOption(
                  activeOption + 1
                );
              }

              else if (
                event.key ===
                "ArrowUp"
              ) {
                event.preventDefault();

                setActiveOption(
                  activeOption - 1
                );
              }

              else if (
                event.key ===
                  "Enter" &&
                activeOption >= 0 &&
                activeOption <
                  optionCount
              ) {
                event.preventDefault();

                selectAddress(
                  currentResults[
                    activeOption
                  ]
                );
              }

              else if (
                event.key ===
                "Escape"
              ) {
                hideSuggestions();
              }
            }
          );

          addressInput.addEventListener(
            "blur",
            function () {
              window.setTimeout(
                hideSuggestions,
                150
              );
            }
          );
        }
      );
  }


  function renderLearnerForms() {
    ensureLearnerCount();


    const container =
      document.getElementById(
        "quess-training-learners-container"
      );


    if (!container) {
      return;
    }


    container.innerHTML =
      learners
        .map(
          function (
            learner,
            index
          ) {
            const number =
              index + 1;


            return `
              <details
                class="quess-training-learner-card"
                ${number === 1 ? "open" : ""}
              >
                <summary>
                  Learner ${number}
                  ${
                    learner.firstName ||
                    learner.lastName
                      ? `— ${escapeHtml(
                          getLearnerDisplayName(
                            learner
                          )
                        )}`
                      : ""
                  }
                </summary>

                <div class="quess-training-learner-fields">
                  <div class="quess-training-form-grid">

                    ${createTextField({
                      learnerIndex: index,
                      field: "firstName",
                      label: "First name",
                      value: learner.firstName,
                      required: true,
                      autocomplete: "given-name"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "lastName",
                      label: "Last name",
                      value: learner.lastName,
                      required: true,
                      autocomplete: "family-name"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "email",
                      label: "Email",
                      type: "email",
                      value: learner.email,
                      required: true,
                      autocomplete: "email"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "requestedUsername",
                      label: "Requested username",
                      value: learner.requestedUsername,
                      required: true,
                      autocomplete: "username"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "phone",
                      label: "Phone number",
                      type: "tel",
                      value: learner.phone,
                      autocomplete: "tel"
                    })}

                    <div class="quess-training-field">
                      <label>
                        Gender
                        <span class="quess-training-required">*</span>
                      </label>

                      <select
                        data-learner-index="${index}"
                        data-learner-field="gender"
                      >
                        <option value="">Select</option>
                        <option
                          value="female"
                          ${learner.gender === "female" ? "selected" : ""}
                        >
                          Female
                        </option>
                        <option
                          value="male"
                          ${learner.gender === "male" ? "selected" : ""}
                        >
                          Male
                        </option>
                        <option
                          value="non_binary"
                          ${learner.gender === "non_binary" ? "selected" : ""}
                        >
                          Non-binary
                        </option>
                        <option
                          value="prefer_not_to_say"
                          ${learner.gender === "prefer_not_to_say" ? "selected" : ""}
                        >
                          Prefer not to say
                        </option>
                      </select>
                    </div>

                    <div class="quess-training-field">
                      <label>
                        Professional title
                        <span class="quess-training-required">*</span>
                      </label>

                      <select
                        data-learner-index="${index}"
                        data-learner-field="professionalTitle"
                      >
                        <option value="">Select</option>
                        <option
                          value="Pharmacist"
                          ${learner.professionalTitle === "Pharmacist" ? "selected" : ""}
                        >
                          Pharmacist
                        </option>
                        <option
                          value="Pharmacy technician"
                          ${learner.professionalTitle === "Pharmacy technician" ? "selected" : ""}
                        >
                          Pharmacy technician
                        </option>
                        <option
                          value="Pharmacy technician assistant"
                          ${learner.professionalTitle === "Pharmacy technician assistant" ? "selected" : ""}
                        >
                          Pharmacy technician assistant
                        </option>
                        <option
                          value="Housekeeping personnel"
                          ${learner.professionalTitle === "Housekeeping personnel" ? "selected" : ""}
                        >
                          Housekeeping personnel
                        </option>
                        <option
                          value="Environmental services personnel"
                          ${learner.professionalTitle === "Environmental services personnel" ? "selected" : ""}
                        >
                          Environmental services personnel
                        </option>
                        <option
                          value="Technical services personnel"
                          ${learner.professionalTitle === "Technical services personnel" ? "selected" : ""}
                        >
                          Technical services personnel
                        </option>
                        <option
                          value="Other"
                          ${learner.professionalTitle === "Other" ? "selected" : ""}
                        >
                          Other
                        </option>
                      </select>
                    </div>




                    ${createTextField({
                      learnerIndex: index,
                      field: "addressLine1",
                      label: "Address",
                      value: learner.addressLine1,
                      required: true,
                      autocomplete: "address-line1",
                      fullWidth: true
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "addressLine2",
                      label: "Address line 2",
                      value: learner.addressLine2,
                      autocomplete: "address-line2"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "country",
                      label: "Country",
                      value: learner.country,
                      required: true,
                      autocomplete: "country-name"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "provinceState",
                      label: "Province or state",
                      value: learner.provinceState,
                      required: true,
                      autocomplete: "address-level1"
                    })}

                    ${createTextField({
                      learnerIndex: index,
                      field: "postalCode",
                      label: "Postal or ZIP code",
                      value: learner.postalCode,
                      required: true,
                      autocomplete: "postal-code"
                    })}

                    ${
                      isUnitedStatesMarket
                        ? `
                          ${createTextField({
                            learnerIndex: index,
                            field: "dateOfBirthMonthDay",
                            label: "Date of birth (MM/DD)",
                            value: learner.dateOfBirthMonthDay,
                            required: true,
                            placeholder: "MM/DD",
                            inputMode: "numeric",
                            maxLength: 5,
                            autocomplete: "off"
                          })}

                          ${createTextField({
                            learnerIndex: index,
                            field: "cpeMonitorId",
                            label: "NABP e-Profile ID (ePID)",
                            value: learner.cpeMonitorId,
                            required: true,
                            inputMode: "numeric",
                            autocomplete: "off"
                          })}
                        `
                        : ""
                    }

                    <label class="quess-training-inline-checkbox">
                      <input
                        type="checkbox"
                        data-learner-index="${index}"
                        data-learner-field="marketingConsent"
                        ${
                          learner.marketingConsent
                            ? "checked"
                            : ""
                        }
                      >

                      <span>
                        This learner would like to receive
                        relevant QUESS 360 updates by email.
                      </span>
                    </label>

                  </div>
                </div>
              </details>
            `;
          }
        )
        .join("");

    initializeAddressAutocomplete(
      container
    );
  }


  function createTextField(
    settings
  ) {
    return `
      <div class="
        quess-training-field
        ${
          settings.fullWidth
            ? "quess-training-field--full"
            : ""
        }
      ">
        <label>
          ${escapeHtml(
            settings.label
          )}

          ${
            settings.required
              ? '<span class="quess-training-required">*</span>'
              : ""
          }
        </label>

        <input
          type="${escapeHtml(
            settings.type || "text"
          )}"
          value="${escapeHtml(
            settings.value || ""
          )}"
          data-learner-index="${settings.learnerIndex}"
          data-learner-field="${escapeHtml(
            settings.field
          )}"
          ${
            settings.autocomplete
              ? `autocomplete="${escapeHtml(
                  settings.autocomplete
                )}"`
              : ""
          }
          ${
            settings.placeholder
              ? `placeholder="${escapeHtml(
                  settings.placeholder
                )}"`
              : ""
          }
          ${
            settings.inputMode
              ? `inputmode="${escapeHtml(
                  settings.inputMode
                )}"`
              : ""
          }
          ${
            settings.maxLength
              ? `maxlength="${escapeHtml(
                  settings.maxLength
                )}"`
              : ""
          }
        >
      </div>
    `;
  }


  function renderAssignments() {
    initializeAssignments();


    const container =
      document.getElementById(
        "quess-training-assignments-container"
      );


    if (!container) {
      return;
    }


    container.innerHTML =
      getTrainingItems()
        .map(
          function (
            trainingItem
          ) {
            const key =
              getCourseAssignmentKey(
                trainingItem
              );


            const requiredSeats =
              Number(
                trainingItem.quantity || 0
              );


            const assigned =
              getAssignedLearnerNumbers(
                trainingItem
              );


            const isAutomatic =
              requiredSeats ===
              selectedLearnerCount;


            const isComplete =
              assigned.length ===
              requiredSeats;


            const options =
              learners
                .map(
                  function (
                    learner
                  ) {
                    const checked =
                      assigned.includes(
                        learner.learnerNumber
                      );


                    const limitReached =
                      assigned.length >=
                      requiredSeats;


                    const disabled =
                      isAutomatic ||
                      (
                        !checked &&
                        limitReached
                      );


                    return `
                      <label class="
                        quess-training-assignment-option
                        ${disabled ? "is-disabled" : ""}
                      ">
                        <input
                          type="checkbox"
                          data-assignment-key="${escapeHtml(
                            key
                          )}"
                          data-assignment-learner="${learner.learnerNumber}"
                          ${checked ? "checked" : ""}
                          ${disabled ? "disabled" : ""}
                        >

                        <span>
                          <strong>
                            ${escapeHtml(
                              getLearnerDisplayName(
                                learner
                              )
                            )}
                          </strong>

                          <span class="quess-training-assignment-email">
                            ${escapeHtml(
                              learner.email ||
                              `Learner ${learner.learnerNumber}`
                            )}
                          </span>
                        </span>
                      </label>
                    `;
                  }
                )
                .join("");


            return `
              <div class="quess-training-assignment-card">
                <div class="quess-training-assignment-header">
                  <div>
                    <h3>
                      ${escapeHtml(
                        trainingItem.productTitle ||
                        "Training"
                      )}
                    </h3>

                    ${
                      trainingItem.lmsCourseId
                        ? ""
                        : `
                          <p class="quess-training-required">
                            This training is missing its LMS course ID.
                          </p>
                        `
                    }
                  </div>

                  <span class="
                    quess-training-assignment-counter
                    ${isComplete ? "is-complete" : ""}
                  ">
                    ${assigned.length} of
                    ${requiredSeats} assigned
                  </span>
                </div>

                <div class="quess-training-assignment-options">
                  ${options}
                </div>

                ${
                  isAutomatic
                    ? `
                      <p class="quess-training-automatic-note">
                        This training has been assigned
                        automatically to every learner.
                      </p>
                    `
                    : ""
                }
              </div>
            `;
          }
        )
        .join("");
  }


  /*
  =========================================
  STEP NAVIGATION
  =========================================
  */

  function showStep(
    stepName
  ) {
    currentStep =
      stepName;


    document
      .querySelectorAll(
        "[data-registration-step]"
      )
      .forEach(
        function (
          step
        ) {
          step.hidden =
            step.getAttribute(
              "data-registration-step"
            ) !== stepName;
        }
      );


    const readyStep =
      document.getElementById(
        "quess-training-ready-step"
      );


    readyStep?.classList.remove(
      "is-visible"
    );


    document
      .querySelectorAll(
        "[data-progress-step]"
      )
      .forEach(
        function (
          progressStep
        ) {
          const progressName =
            progressStep.getAttribute(
              "data-progress-step"
            );


          const order = {
            selection: 1,
            information: 2,
            assignment: 3
          };


          progressStep.classList.toggle(
            "is-active",
            progressName ===
              stepName
          );


          progressStep.classList.toggle(
            "is-complete",
            order[progressName] <
              order[stepName]
          );
        }
      );


    clearRegistrationError();


    const modal =
      document.getElementById(
        "quess-training-registration-modal"
      );


    if (modal) {
      modal.scrollTop = 0;
    }
  }


  function showReadyStep() {
    currentStep = "ready";


    document
      .querySelectorAll(
        "[data-registration-step]"
      )
      .forEach(
        function (
          step
        ) {
          step.hidden = true;
        }
      );


    document
      .querySelectorAll(
        "[data-progress-step]"
      )
      .forEach(
        function (
          progressStep
        ) {
          progressStep.classList.remove(
            "is-active"
          );

          progressStep.classList.add(
            "is-complete"
          );
        }
      );


    document
      .getElementById(
        "quess-training-ready-step"
      )
      ?.classList.add(
        "is-visible"
      );


    clearRegistrationError();
  }


  /*
  =========================================
  VALIDATION
  =========================================
  */

  function showRegistrationError(
    message
  ) {
    const errorElement =
      document.getElementById(
        "quess-training-registration-error"
      );


    if (!errorElement) {
      return;
    }


    errorElement.textContent =
      message;


    errorElement.classList.add(
      "is-visible"
    );


    errorElement.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }


  function clearRegistrationError() {
    const errorElement =
      document.getElementById(
        "quess-training-registration-error"
      );


    errorElement?.classList.remove(
      "is-visible"
    );


    if (errorElement) {
      errorElement.textContent = "";
    }
  }


  function isValidEmail(
    email
  ) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      email
    );
  }


  function isValidUsername(
    username
  ) {
    return /^[A-Za-z0-9._-]{3,50}$/.test(
      username
    );
  }


  function isValidBirthMonthDay(
    value
  ) {
    const match =
      /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/.exec(
        String(value || "").trim()
      );


    if (!match) {
      return false;
    }


    const month =
      Number(match[1]);


    const day =
      Number(match[2]);


    const daysInMonth = [
      31,
      29,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31
    ];


    return day <=
      daysInMonth[month - 1];
  }


  function validateLearners() {
    ensureLearnerCount();


    const emails =
      new Set();


    const usernames =
      new Set();


    for (
      let index = 0;
      index < learners.length;
      index += 1
    ) {
      const learner =
        learners[index];


      const learnerLabel =
        `Learner ${index + 1}`;


      const requiredFields = [
        ["firstName", "first name"],
        ["lastName", "last name"],
        ["email", "email"],
        ["requestedUsername", "username"],
        ["gender", "gender"],
        [
          "professionalTitle",
          "professional title"
        ],
        ["country", "country"],
        [
          "provinceState",
          "province or state"
        ],
        ["addressLine1", "address"],
        ["postalCode", "postal code"],
      ];


      for (
        const [
          field,
          label
        ] of requiredFields
      ) {
        if (
          !String(
            learner[field] || ""
          ).trim()
        ) {
          return `${learnerLabel}: ${label} is required.`;
        }
      }


      if (isUnitedStatesMarket) {
        if (
          !String(
            learner.dateOfBirthMonthDay || ""
          ).trim()
        ) {
          return `${learnerLabel}: date of birth is required.`;
        }


        if (
          !isValidBirthMonthDay(
            learner.dateOfBirthMonthDay
          )
        ) {
          return `${learnerLabel}: enter the date of birth as MM/DD.`;
        }


        if (
          !String(
            learner.cpeMonitorId || ""
          ).trim()
        ) {
          return `${learnerLabel}: NABP e-Profile ID (ePID) is required.`;
        }
      }


      const normalizedEmail =
        learner.email
          .trim()
          .toLowerCase();


      if (
        !isValidEmail(
          normalizedEmail
        )
      ) {
        return `${learnerLabel}: enter a valid email address.`;
      }


      if (
        emails.has(
          normalizedEmail
        )
      ) {
        return "Every learner must have a different email address.";
      }


      emails.add(
        normalizedEmail
      );


      const normalizedUsername =
        learner.requestedUsername
          .trim()
          .toLowerCase();


      if (
        !isValidUsername(
          learner.requestedUsername.trim()
        )
      ) {
        return `${learnerLabel}: the username must contain 3–50 letters, numbers, periods, underscores or hyphens.`;
      }


      if (
        usernames.has(
          normalizedUsername
        )
      ) {
        return "Every learner must have a different username.";
      }


      usernames.add(
        normalizedUsername
      );


    }


    return "";
  }


  function validateAssignments() {
    const trainingItems =
      getTrainingItems();


    for (
      const trainingItem of
      trainingItems
    ) {
      if (
        !trainingItem.lmsCourseId
      ) {
        return `${trainingItem.productTitle} is missing its LMS course ID.`;
      }


      const requiredSeats =
        Number(
          trainingItem.quantity || 0
        );


      const assigned =
        getAssignedLearnerNumbers(
          trainingItem
        );


      if (
        assigned.length !==
        requiredSeats
      ) {
        return `${trainingItem.productTitle}: assign exactly ${requiredSeats} learner${requiredSeats === 1 ? "" : "s"}.`;
      }
    }


    for (
      const learner of
      learners
    ) {
      const hasAssignment =
        trainingItems.some(
          function (
            trainingItem
          ) {
            return getAssignedLearnerNumbers(
              trainingItem
            ).includes(
              learner.learnerNumber
            );
          }
        );


      if (!hasAssignment) {
        return `${getLearnerDisplayName(learner)} must receive at least one training.`;
      }
    }


    if (
      !registrationConsent
        .informationConfirmed
    ) {
      return "Confirm that the learner information and assignments are accurate.";
    }


    if (
      !registrationConsent
        .processingConsent
    ) {
      return "Processing consent is required.";
    }


    if (
      !registrationConsent
        .termsAccepted
    ) {
      return "You must accept the terms and conditions.";
    }


    return "";
  }


  /*
  =========================================
  PAYLOAD
  =========================================
  */

  function buildRegistrationPayload() {
    const trainingItems =
      getTrainingItems();


    return {
      cartToken:
        String(
          trainingCartState
            ?.cartToken || ""
        ),

      marketCountryCode:
        storefrontCountryCode || "CA",

      isForOtherPeople,

      learnerCount:
        selectedLearnerCount,

      learners:
        learners.map(
          function (
            learner
          ) {
            return {
              ...learner,

              firstName:
                learner.firstName.trim(),

              lastName:
                learner.lastName.trim(),

              email:
                learner.email
                  .trim()
                  .toLowerCase(),

              requestedUsername:
                learner.requestedUsername
                  .trim(),

              phone:
                learner.phone.trim(),

              dateOfBirthMonthDay:
                isUnitedStatesMarket
                  ? String(
                      learner.dateOfBirthMonthDay || ""
                    ).trim()
                  : "",

              cpeMonitorReporting:
                isUnitedStatesMarket,

              cpeMonitorId:
                isUnitedStatesMarket
                  ? String(
                      learner.cpeMonitorId || ""
                    ).trim()
                  : ""
            };
          }
        ),

      trainingItems:
        trainingItems.map(
          function (
            item
          ) {
            return {
              lineKey:
                item.lineKey,

              productId:
                item.productId,

              variantId:
                item.variantId,

              productTitle:
                item.productTitle,

              variantTitle:
                item.variantTitle,

              quantity:
                item.quantity,

              lmsCourseId:
                item.lmsCourseId,

              finalLinePrice:
                item.finalLinePrice
            };
          }
        ),

      assignments:
        trainingItems.flatMap(
          function (
            item
          ) {
            return getAssignedLearnerNumbers(
              item
            ).map(
              function (
                learnerNumber
              ) {
                return {
                  learnerNumber,

                  shopifyVariantId:
                    item.variantId,

                  lmsCourseId:
                    item.lmsCourseId,

                  productTitle:
                    item.productTitle
                };
              }
            );
          }
        ),

      consents: {
        informationConfirmed:
          registrationConsent
            .informationConfirmed,

        processingConsent:
          registrationConsent
            .processingConsent,

        termsAccepted:
          registrationConsent
            .termsAccepted
      },

      createdAt:
        new Date().toISOString()
    };
  }

  /*
=========================================
SUPABASE SAVE AND SHOPIFY CHECKOUT
=========================================
*/


function getShopifyRoute(
  path
) {
  const normalizedRoot =
    shopifyRoot.endsWith("/")
      ? shopifyRoot
      : `${shopifyRoot}/`;


  return (
    normalizedRoot +
    String(path || "")
      .replace(/^\/+/, "")
  );
}


function createClientRequestId() {
  if (
    window.crypto &&
    typeof window.crypto.randomUUID ===
      "function"
  ) {
    return window.crypto.randomUUID();
  }


  const bytes =
    new Uint8Array(16);


  window.crypto.getRandomValues(
    bytes
  );


  /*
  Set the UUID version and variant bits.
  */

  bytes[6] =
    (
      bytes[6] & 0x0f
    ) | 0x40;


  bytes[8] =
    (
      bytes[8] & 0x3f
    ) | 0x80;


  const hex =
    Array.from(
      bytes
    ).map(
      function (
        byte
      ) {
        return byte
          .toString(16)
          .padStart(2, "0");
      }
    );


  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join("")
  ].join("-");
}


/*
Create an opaque hash of the completed
form.

The hash lets us reuse the same request ID
after a temporary network failure without
storing learner information in browser
storage.
*/

async function createPayloadHash(
  payload
) {
  const stablePayload = {
    ...payload
  };


  delete stablePayload.clientRequestId;
  delete stablePayload.createdAt;


  const serialized =
    JSON.stringify(
      stablePayload
    );


  if (
    window.crypto &&
    window.crypto.subtle
  ) {
    const encoded =
      new TextEncoder().encode(
        serialized
      );


    const digest =
      await window.crypto.subtle.digest(
        "SHA-256",
        encoded
      );


    return Array.from(
      new Uint8Array(
        digest
      )
    )
      .map(
        function (
          byte
        ) {
          return byte
            .toString(16)
            .padStart(2, "0");
        }
      )
      .join("");
  }


  /*
  Compatibility fallback.
  */

  let hash =
    2166136261;


  for (
    let index = 0;
    index < serialized.length;
    index += 1
  ) {
    hash ^=
      serialized.charCodeAt(
        index
      );


    hash =
      Math.imul(
        hash,
        16777619
      );
  }


  return (
    "fallback-" +
    (
      hash >>> 0
    ).toString(16)
  );
}


function readRegistrationRequestState() {
  try {
    const rawState =
      sessionStorage.getItem(
        REGISTRATION_REQUEST_STORAGE_KEY
      );


    if (!rawState) {
      return null;
    }


    const parsedState =
      JSON.parse(
        rawState
      );


    if (
      !parsedState ||
      typeof parsedState !== "object"
    ) {
      return null;
    }


    return parsedState;
  }


  catch (error) {
    sessionStorage.removeItem(
      REGISTRATION_REQUEST_STORAGE_KEY
    );


    return null;
  }
}


function writeRegistrationRequestState(
  state
) {
  sessionStorage.setItem(
    REGISTRATION_REQUEST_STORAGE_KEY,

    JSON.stringify(
      state
    )
  );
}


async function prepareRegistrationRequest() {
  const payload =
    buildRegistrationPayload();


  const payloadHash =
    await createPayloadHash(
      payload
    );


  const cartToken =
    String(
      payload.cartToken || ""
    );


  let requestState =
    readRegistrationRequestState();


  /*
  Generate a new request ID when:

  - this is a different cart
  - the learner information changed
  - the assignments changed
  */

  if (
    !requestState ||
    requestState.cartToken !==
      cartToken ||
    requestState.payloadHash !==
      payloadHash
  ) {
    requestState = {
      cartToken,

      payloadHash,

      clientRequestId:
        createClientRequestId(),

      registrationId:
        null
    };
  }


  payload.clientRequestId =
    requestState.clientRequestId;


  payload.createdAt =
    new Date().toISOString();


  writeRegistrationRequestState(
    requestState
  );


  return {
    payload,
    requestState
  };
}


async function saveTrainingRegistration(
  payload
) {
  if (
    TRAINING_REGISTRATION_ENDPOINT.includes(
      "YOUR_PROJECT_REF"
    )
  ) {
    throw new Error(
      "The Supabase training-registration endpoint has not been configured."
    );
  }


  const response =
    await fetch(
      TRAINING_REGISTRATION_ENDPOINT,
      {
        method: "POST",

        mode: "cors",

        credentials: "omit",

        headers: {
          "Content-Type":
            "application/json",

          "Accept":
            "application/json"
        },

        body:
          JSON.stringify(
            payload
          )
      }
    );


  const result =
    await response
      .json()
      .catch(
        function () {
          return {};
        }
      );


  if (
    !response.ok ||
    result.ok !== true
  ) {
    throw new Error(
      result.error ||
      "The training registration could not be saved."
    );
  }


  if (
    typeof result.registrationId !==
      "string" ||
    !result.registrationId
  ) {
    throw new Error(
      "Supabase did not return a training registration ID."
    );
  }


  return result.registrationId;
}


async function attachRegistrationToCart(
  registrationId
) {
  const response =
    await fetch(
      getShopifyRoute(
        "cart/update.js"
      ),
      {
        method: "POST",

        credentials:
          "same-origin",

        headers: {
          "Content-Type":
            "application/json",

          "Accept":
            "application/json"
        },

        body:
          JSON.stringify({
            attributes: {
              [PRIVATE_CART_ATTRIBUTE]:
                registrationId
            }
          })
      }
    );


  if (!response.ok) {
    throw new Error(
      "The registration was saved, but it could not be connected to the Shopify cart."
    );
  }


  /*
  Read the response so the Shopify request
  fully completes before checkout begins.
  */

  await response.json();
}


function setRegistrationSubmitting(
  isSubmitting
) {
  registrationSubmissionRunning =
    isSubmitting;


  const button =
    document.getElementById(
      "quess-training-registration-validate"
    );


  if (!button) {
    return;
  }


  button.disabled =
    isSubmitting;


  button.textContent =
    isSubmitting
      ? "Saving registration..."
      : "Save and continue to checkout";
}


function continueToShopifyCheckout() {
  window.location.assign(
    getShopifyRoute(
      "checkout"
    )
  );
}


async function submitTrainingRegistration() {
  if (
    registrationSubmissionRunning
  ) {
    return;
  }


  clearRegistrationError();


  setRegistrationSubmitting(
    true
  );


  let checkoutStarting =
    false;


  try {
    const {
      payload,
      requestState
    } =
      await prepareRegistrationRequest();


    /*
    Keep the final payload available for
    inspection and troubleshooting.
    */

    window.QuessTrainingRegistrationPayload =
      payload;


    const registrationId =
      await saveTrainingRegistration(
        payload
      );


    savedRegistrationId =
      registrationId;


    writeRegistrationRequestState({
      ...requestState,

      registrationId
    });


    /*
    Attach only the opaque registration ID
    to Shopify. Learner information remains
    in Supabase.
    */

    await attachRegistrationToCart(
      registrationId
    );


    window.QuessTrainingRegistrationId =
      registrationId;


    document.dispatchEvent(
      new CustomEvent(
        "quess:training-registration-saved",
        {
          detail: {
            registrationId
          }
        }
      )
    );


    showReadyStep();


    checkoutStarting =
      true;


    window.setTimeout(
      continueToShopifyCheckout,
      250
    );
  }


  catch (error) {
    const message =
      error instanceof Error
        ? error.message
        : "The training registration could not be saved.";


    console.error(
      "QUESS training registration error:",
      error
    );


    showRegistrationError(
      message
    );
  }


  finally {
    if (!checkoutStarting) {
      setRegistrationSubmitting(
        false
      );
    }
  }
}

  /*
  =========================================
  MODAL OPEN / CLOSE
  =========================================
  */

  function openTrainingRegistrationModal() {
    if (
      !trainingCartState?.hasTraining
    ) {
      return;
    }


    const overlay =
      createTrainingRegistrationModal();


    lastFocusedElement =
      document.activeElement;


    renderTrainingSummary();
    loadRegistrationTypeDraft();
    renderLearnerCount();
    showStep(
      currentStep === "ready"
        ? "selection"
        : currentStep
    );


    const checkbox =
      document.getElementById(
        "quess-training-for-others"
      );


    const countSection =
      document.getElementById(
        "quess-training-count-section"
      );


    if (checkbox) {
      checkbox.checked =
        isForOtherPeople;
    }


    countSection?.classList.toggle(
      "is-visible",
      isForOtherPeople
    );


    overlay.classList.add(
      "is-visible"
    );


    document.body.classList.add(
      "quess-training-modal-open"
    );
  }


  function closeTrainingRegistrationModal() {
    document
      .getElementById(
        "quess-training-registration-overlay"
      )
      ?.classList.remove(
        "is-visible"
      );


    document.body.classList.remove(
      "quess-training-modal-open"
    );


    if (
      lastFocusedElement instanceof
      HTMLElement
    ) {
      lastFocusedElement.focus();
    }
  }


  function saveRegistrationTypeDraft() {
    sessionStorage.setItem(
      TYPE_DRAFT_STORAGE_KEY,

      JSON.stringify({
        cartToken:
          String(
            trainingCartState
              ?.cartToken || ""
          ),

        isForOtherPeople,

        learnerCount:
          selectedLearnerCount
      })
    );
  }


  function loadRegistrationTypeDraft() {
    try {
      const raw =
        sessionStorage.getItem(
          TYPE_DRAFT_STORAGE_KEY
        );


      if (!raw) {
        return;
      }


      const draft =
        JSON.parse(
          raw
        );


      if (
        draft.cartToken &&
        trainingCartState?.cartToken &&
        draft.cartToken !==
          trainingCartState.cartToken
      ) {
        return;
      }


      isForOtherPeople =
        draft.isForOtherPeople ===
        true;


      selectedLearnerCount =
        isForOtherPeople
          ? clampLearnerCount(
              draft.learnerCount
            )
          : 1;
    }


    catch (error) {
      sessionStorage.removeItem(
        TYPE_DRAFT_STORAGE_KEY
      );
    }
  }


  /*
  =========================================
  EVENTS
  =========================================
  */

  function attachModalEvents(
    overlay
  ) {
    overlay.addEventListener(
      "click",

      async function (
        event
      ) {
        if (
          !(
            event.target instanceof
            Element
          )
        ) {
          return;
        }


        if (
          event.target.closest(
            ".quess-training-modal-close"
          ) ||
          event.target.closest(
            "[data-close-registration]"
          )
        ) {
          closeTrainingRegistrationModal();

          return;
        }


        if (
          event.target.closest(
            "#quess-training-count-minus"
          )
        ) {
          selectedLearnerCount =
            clampLearnerCount(
              selectedLearnerCount - 1
            );

          renderLearnerCount();

          return;
        }


        if (
          event.target.closest(
            "#quess-training-count-plus"
          )
        ) {
          selectedLearnerCount =
            clampLearnerCount(
              selectedLearnerCount + 1
            );

          renderLearnerCount();

          return;
        }


        if (
          event.target.closest(
            "#quess-training-selection-continue"
          )
        ) {
          clearRegistrationError();


          if (
            !isForOtherPeople &&
            getMinimumLearnerCount() > 1
          ) {
            showRegistrationError(
              `Your cart requires at least ${getMinimumLearnerCount()} learners. Select “The trainings are for other people.”`
            );

            return;
          }


          selectedLearnerCount =
            isForOtherPeople
              ? clampLearnerCount(
                  selectedLearnerCount
                )
              : 1;


          saveRegistrationTypeDraft();
          ensureLearnerCount();
          renderLearnerForms();
          showStep("information");

          return;
        }


        if (
          event.target.closest(
            "#quess-training-information-back"
          )
        ) {
          showStep("selection");

          return;
        }


        if (
          event.target.closest(
            "#quess-training-information-continue"
          )
        ) {
          const learnerError =
            validateLearners();


          if (learnerError) {
            showRegistrationError(
              learnerError
            );

            return;
          }


          initializeAssignments();
          renderAssignments();
          showStep("assignment");

          return;
        }


        if (
          event.target.closest(
            "#quess-training-assignment-back"
          )
        ) {
          renderLearnerForms();
          showStep("information");

          return;
        }


                if (
          event.target.closest(
            "#quess-training-registration-validate"
          )
        ) {
          const assignmentError =
            validateAssignments();


          if (assignmentError) {
            showRegistrationError(
              assignmentError
            );

            return;
          }


          await submitTrainingRegistration();

          return;
        }
      }
    );


    overlay.addEventListener(
      "input",

      function (
        event
      ) {
        if (
          !(
            event.target instanceof
            HTMLInputElement
          ) &&
          !(
            event.target instanceof
            HTMLSelectElement
          )
        ) {
          return;
        }


        const learnerIndex =
          Number(
            event.target.getAttribute(
              "data-learner-index"
            )
          );


        const learnerField =
          event.target.getAttribute(
            "data-learner-field"
          );


        if (
          Number.isInteger(
            learnerIndex
          ) &&
          learnerField &&
          learners[learnerIndex]
        ) {
          if (
            learnerField ===
              "dateOfBirthMonthDay" &&
            event.target instanceof
              HTMLInputElement
          ) {
            const digits =
              event.target.value
                .replace(/[^0-9]/g, "")
                .slice(0, 4);


            event.target.value =
              digits.length > 2
                ? `${digits.slice(0, 2)}/${digits.slice(2)}`
                : digits;
          }


          learners[learnerIndex][
            learnerField
          ] =
            event.target.type ===
            "checkbox"
              ? event.target.checked
              : event.target.value;
        }
      }
    );


        overlay.addEventListener(
      "change",

      function (
        event
      ) {
        if (
          !(
            event.target instanceof
            HTMLInputElement
          ) &&
          !(
            event.target instanceof
            HTMLSelectElement
          )
        ) {
          return;
        }


        if (
          event.target.id ===
          "quess-training-for-others"
        ) {
          isForOtherPeople =
            event.target.checked;


          selectedLearnerCount =
            isForOtherPeople
              ? getMinimumLearnerCount()
              : 1;


          document
            .getElementById(
              "quess-training-count-section"
            )
            ?.classList.toggle(
              "is-visible",
              isForOtherPeople
            );


          renderLearnerCount();

          return;
        }


        if (
          event.target.id ===
          "quess-training-learner-count"
        ) {
          selectedLearnerCount =
            clampLearnerCount(
              event.target.value
            );


          renderLearnerCount();

          return;
        }


        const learnerIndex =
          Number(
            event.target.getAttribute(
              "data-learner-index"
            )
          );


        const learnerField =
          event.target.getAttribute(
            "data-learner-field"
          );


        if (
          Number.isInteger(
            learnerIndex
          ) &&
          learnerField &&
          learners[learnerIndex]
        ) {
          learners[learnerIndex][
            learnerField
          ] =
            event.target.type ===
            "checkbox"
              ? event.target.checked
              : event.target.value;




          return;
        }


        const assignmentKey =
          event.target.getAttribute(
            "data-assignment-key"
          );


        const assignmentLearner =
          Number(
            event.target.getAttribute(
              "data-assignment-learner"
            )
          );


        if (
          assignmentKey &&
          Number.isInteger(
            assignmentLearner
          )
        ) {
          const current =
            Array.isArray(
              assignments[
                assignmentKey
              ]
            )
              ? [
                  ...assignments[
                    assignmentKey
                  ]
                ]
              : [];


          let nextAssignments =
            current;


          if (
            event.target.checked
          ) {
            if (
              !current.includes(
                assignmentLearner
              )
            ) {
              nextAssignments = [
                ...current,
                assignmentLearner
              ];
            }
          }


          else {
            nextAssignments =
              current.filter(
                function (
                  learnerNumber
                ) {
                  return (
                    learnerNumber !==
                    assignmentLearner
                  );
                }
              );
          }


          assignments[
            assignmentKey
          ] =
            nextAssignments;


          renderAssignments();

          return;
        }


        if (
          event.target.id ===
          "quess-training-information-confirmed"
        ) {
          registrationConsent
            .informationConfirmed =
              event.target.checked;

          return;
        }


        if (
          event.target.id ===
          "quess-training-processing-consent"
        ) {
          registrationConsent
            .processingConsent =
              event.target.checked;

          return;
        }


        if (
          event.target.id ===
          "quess-training-terms-accepted"
        ) {
          registrationConsent
            .termsAccepted =
              event.target.checked;
        }
      }
    );


        document.addEventListener(
      "keydown",

      function (
        event
      ) {
        if (
          event.key === "Escape" &&
          overlay.classList.contains(
            "is-visible"
          )
        ) {
          closeTrainingRegistrationModal();
        }
      }
    );
  }


  /*
  =========================================
  CHECKOUT INTERCEPTION
  =========================================
  */

  function getCheckoutControl(
    target
  ) {
    if (
      !(
        target instanceof Element
      )
    ) {
      return null;
    }


    return target.closest(
      [
        'button[name="checkout"]',
        'input[name="checkout"]',
        "[data-checkout]",
        'a[href*="/checkout"]'
      ].join(",")
    );
  }


  document.addEventListener(
    "click",

    function (
      event
    ) {
      const checkoutControl =
        getCheckoutControl(
          event.target
        );


      if (
        !checkoutControl ||
        !trainingCartState?.hasTraining
      ) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      openTrainingRegistrationModal();
    },

    true
  );


  document.addEventListener(
    "submit",

    function (
      event
    ) {
      const checkoutControl =
        getCheckoutControl(
          event.submitter
        );


      if (
        !checkoutControl ||
        !trainingCartState?.hasTraining
      ) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      openTrainingRegistrationModal();
    },

    true
  );


  /*
  =========================================
  TRAINING DETECTOR CONNECTION
  =========================================
  */

  function updateTrainingCartState(
    state
  ) {
    trainingCartState =
      state;


    if (
      !trainingCartState
        ?.hasTraining
    ) {
      closeTrainingRegistrationModal();

      sessionStorage.removeItem(
        TYPE_DRAFT_STORAGE_KEY
      );

      sessionStorage.removeItem(
  REGISTRATION_REQUEST_STORAGE_KEY
);


savedRegistrationId =
  null;

      learners = [];
      assignments = {};
      isForOtherPeople = false;
      selectedLearnerCount = 1;
      currentStep = "selection";
    }
  }


  document.addEventListener(
    "quess:training-cart-updated",

    function (
      event
    ) {
      updateTrainingCartState(
        event.detail
      );
    }
  );


  /*
  =========================================
  PUBLIC API
  =========================================
  */

  window.QuessTrainingRegistration = {
    open:
      openTrainingRegistrationModal,

    close:
      closeTrainingRegistrationModal,

    getPayload:
      function () {
        return buildRegistrationPayload();
      },

      getRegistrationId:
  function () {
    return savedRegistrationId;
  },

    getCurrentStep:
      function () {
        return currentStep;
      }
  };


  function initializeTrainingRegistrationModal() {
    createTrainingRegistrationModal();


    if (
      window.QuessTrainingCart
    ) {
      updateTrainingCartState(
        window.QuessTrainingCart
      );
    }
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initializeTrainingRegistrationModal,
      {
        once: true
      }
    );
  }


  else {
    initializeTrainingRegistrationModal();
  }
})();
